import React, { useState } from 'react';
import { useResponsive } from '../../hooks/useResponsive';
import { X, UserPlus, Save } from 'lucide-react';

function AddManagerModal({ onClose, onAdd }) {
  const [managerName, setManagerName] = useState('');
  const { isMobile } = useResponsive();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (managerName.trim()) {
      onAdd(managerName);
      setManagerName('');
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(44, 62, 80, 0.85)',
      backdropFilter: 'blur(4px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      padding: isMobile ? '16px' : '20px'
    }} onClick={onClose}>
      <div 
        className="card" 
        style={{ 
          width: '100%',
          maxWidth: isMobile ? '100%' : '480px',
          margin: 0,
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
          padding: isMobile ? '20px' : '28px'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          marginBottom: isMobile ? '20px' : '24px',
          paddingBottom: '16px',
          borderBottom: '2px solid #e8ecf1',
          flexWrap: 'wrap',
          gap: '12px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? '10px' : '12px', flex: 1 }}>
            <div style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              padding: isMobile ? '8px' : '10px',
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <UserPlus size={isMobile ? 18 : 20} color="white" />
            </div>
            <h3 style={{ 
              margin: 0, 
              fontSize: isMobile ? '18px' : '22px', 
              fontWeight: '700', 
              color: '#2c3e50' 
            }}>Add New Manager</h3>
          </div>
          <button 
            onClick={onClose}
            style={{
              background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
              border: '2px solid #e8ecf1',
              borderRadius: '10px',
              cursor: 'pointer',
              color: '#495057',
              padding: isMobile ? '6px' : '8px',
              display: 'flex',
              alignItems: 'center',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)';
              e.currentTarget.style.color = '#c62828';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)';
              e.currentTarget.style.color = '#495057';
            }}
          >
            <X size={isMobile ? 18 : 20} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <label>Manager Name</label>
          <input
            type="text"
            value={managerName}
            onChange={(e) => setManagerName(e.target.value)}
            placeholder="Enter manager name"
            required
            autoFocus
            style={{
              fontSize: isMobile ? '14px' : '15px',
              padding: isMobile ? '10px' : '12px'
            }}
          />
          <div style={{ 
            display: 'flex', 
            gap: '12px',
            flexDirection: isMobile ? 'column' : 'row'
          }}>
            <button 
              type="submit" 
              className="btn btn-primary" 
              style={{ 
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                fontWeight: '600',
                fontSize: isMobile ? '14px' : '15px',
                padding: isMobile ? '12px' : '14px'
              }}
            >
              <Save size={isMobile ? 16 : 18} />
              <span>Save Manager</span>
            </button>
            <button 
              type="button" 
              className="btn" 
              style={{ 
                flex: 1, 
                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                color: '#495057',
                fontWeight: '600',
                fontSize: isMobile ? '14px' : '15px',
                border: '2px solid #e8ecf1',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                padding: isMobile ? '12px' : '14px'
              }}
              onClick={onClose}
            >
              <X size={isMobile ? 16 : 18} />
              <span>Cancel</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddManagerModal;
